/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var ColumnResizingMode = /*@__PURE__*/ (function (ColumnResizingMode) {
    ColumnResizingMode[ColumnResizingMode["Deferred"] = 0] = "Deferred";
    ColumnResizingMode[ColumnResizingMode["Immediate"] = 1] = "Immediate";
    ColumnResizingMode[ColumnResizingMode["None"] = 2] = "None";
    return ColumnResizingMode;
})({});
/**
 * @hidden
 */
export var ColumnResizingMode_$type = /*@__PURE__*/ markEnum('ColumnResizingMode', 'Deferred,0|Immediate,1|None,2');
//# sourceMappingURL=ColumnResizingMode.js.map
